<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import NotificationItem from '@/components/notifications/notification-item.vue';

const store = useStore();
const notificationsExceptType = computed(() => store.getters['notifications/notificationsExceptType']);
const filteredNotifications = computed(() => notificationsExceptType.value('resource'));
</script>

<template>
  <div v-if="filteredNotifications.length">
    <NotificationItem
      v-for="notification in filteredNotifications"
      :key="notification.id"
      :notification="notification" />
  </div>
</template>
